import React, { useState } from "react";
import styled from "styled-components";
import { QuizButton } from "../../../types/GeneralStyles";

const BackButtonStyled = styled.button`
  position: fixed;
  z-index:2;
  top: 10px;
  left: 10px;
  width: 50px;
  height:50px;
  border: none;
  background-color:white;
  &:hover{
    background-color: #EEEEEE;
  }
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 15px #3f486599;  
`;
 const BackButton = styled.i`
  width:100%;
  height:100%;
  background-position: 50%;
  background-repeat: no-repeat;
  display:inline-block;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Pro 6.6.0 by %40fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons  Inc.--%3E%3Cpath fill='%23999999' d='M4.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16L54.6 272 155.3 372.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128zM336 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c44.2 0 80 35.8 80 80l0 288c0 44.2-35.8 80-80 80l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-96 0z'/%3E%3C/svg%3E");
  background-size: 30px;
  cursor: pointer;
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #031037de;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const ModalContent = styled.div`
  background-color: #ffffff;
  padding: 0px;
  overflow-y: auto;
  position: relative;
  box-sizing:border-box;
  ${(props) =>
    props.popupType === "fullscreen" &&
    `width: calc( 100vw - 0px);
    height: calc( 100vh - 0px );
    border-radius: 0px;
    // @media only screen and (max-width: 600px) {
    //     padding-left: 10px;
    //     padding-right: 10px;
    // }
    `}
  ${(props) =>
    props.popupType === "allmost_fullscreen" &&
    `width: calc( 100vw - 3vw );
    height: calc( 100vh - 3vw );
    border-radius: 10px;
    @media only screen and (max-width: 600px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`}
  ${(props) =>
    props.popupType === "small" &&
    `max-width: calc( 100vw / 2);
    max-height: calc( 100vh / 1.5 );
    min-width: calc( 100vw / 2.5);
    min-height: calc( 100vw / 4);
    border-radius: 10px;
    @media only screen and (max-width: 1200px) {
      min-width: calc( 100vw / 2);
    }
    @media only screen and (max-width: 960px) {
        max-width: calc( 100vw / 1);
        min-width: calc( 100vw / 1.5);
        min-height: calc( 100vw / 8);
    }
    @media only screen and (max-width: 600px) {
        padding-left: 10px;
        padding-right: 10px;
        max-width: calc( 100vw - 3vw );
        max-height: calc( 100vh - 3vw );
        width: calc( 100vw - 3vw );
        height: calc( 100vh - 3vw );
    }`}
  
`;

// Styled Components for Confirmation Dialog
const ConfirmationOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index:5;
  background-color: #031037de;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: inherit;
`;

const ConfirmationBox = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 15px;
  text-align: left;
  z-index:6;
  max-width: 90%;
`;

const ConfirmationMessage = styled.p`
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
`;

const ConfirmationButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;


const QuizGridModal = ({ children, onClose, popupType, closeButton, bgColor, txtColor }) => {
  const [showConfirm, setShowConfirm] = useState(false);


  // Handle initial close attempt
  const handleAttemptClose = () => {
    setShowConfirm(true);
  };

  // Handle confirmation to close
  const handleConfirmClose = () => {
    setShowConfirm(false);
    if (onClose) {
      onClose();
    }
  };

  // Handle cancellation of close
  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const handleOverlayClick = closeButton && !showConfirm ? handleAttemptClose : undefined;


  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent popupType={popupType} onClick={(e) => e.stopPropagation()}>
        {closeButton && (
          <BackButtonStyled onClick={handleAttemptClose} aria-label="Leave game">
            <BackButton></BackButton>
          </BackButtonStyled>
        )}
        {children}
        {showConfirm && (
          <ConfirmationOverlay>
            <ConfirmationBox>
              <h2>Opgelet:</h2>
              <ConfirmationMessage>Ben je klaar met deze opdracht?</ConfirmationMessage>
              <ConfirmationButtons>
                <QuizButton bgColor={txtColor} txtColor={bgColor} onClick={handleCancelClose}>Nee, ga terug.</QuizButton>
                <QuizButton bgColor={bgColor} txtColor={txtColor} onClick={handleConfirmClose}>Ja, verlaat opdracht.</QuizButton>
              </ConfirmationButtons>
            </ConfirmationBox>
          </ConfirmationOverlay>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default QuizGridModal;
